import { useState, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";

import { ElectricDetailView } from "./component";
import { Product } from "../../../../components/Reusable/type";
import { fetchElectricPlans } from "../../../../features/auth/store/electricPlanSlice";
import { AppDispatch, RootState } from "../../../../redux/store";
import Electric from "./Electric";
import { fetchElectricCategories } from "../../../../features/auth/store/electricCategorySlice";

const ElectricRouter: React.FC = () => {
  const dispatch = useDispatch<AppDispatch>();
  const [statusFilter, setStatusFilter] = useState<string>("");
  const [selectedElectricPlan, setSelectedElectricPlan] =
    useState<Product | null>(null);
  const [showDetailView, setShowDetailView] = useState<boolean>(false);
  const [searchTerm, setSearchTerm] = useState<string>("");

  const { electricPlans, loading, error } = useSelector(
    (state: RootState) => state.electricPlans,
  );

  const { electricCategories } = useSelector(
    (state: RootState) => state.electricCategories,
  );

  const isMounted = useRef(false);

  useEffect(() => {
    if (electricCategories.length == 0) {
      dispatch(fetchElectricCategories({ perPage: 40 }));
    }
  }, []);

  useEffect(() => {
    if (!isMounted.current) {
      isMounted.current = true;
      dispatch(fetchElectricPlans({}));
      return;
    }
    const handler = setTimeout(() => {
      const filters: Record<string, any> = {};

      if (statusFilter) filters.status = statusFilter;
      if (searchTerm.trim()) filters.search = searchTerm.trim();
      dispatch(fetchElectricPlans(filters));
    }, 350);

    return () => clearTimeout(handler);
  }, [dispatch, statusFilter, searchTerm]);

  // Transform DataPlan to Product - ensuring all required fields are present

  const handleElectricPlanClick = (dataPlan: Product) => {
    setSelectedElectricPlan(dataPlan);
    setShowDetailView(true);
  };

  const handleBackToList = () => {
    setShowDetailView(false);
    setSelectedElectricPlan(null);
  };

  if (showDetailView && selectedElectricPlan) {
    return (
      <ElectricDetailView
        electricPlan={{
          ...selectedElectricPlan,
        }}
        onBack={handleBackToList}
      />
    );
  }

  return (
    <Electric
      electricPlans={electricPlans || []}
      loading={loading}
      error={error}
      statusFilter={statusFilter}
      setStatusFilter={setStatusFilter}
      onElectricPlanClick={handleElectricPlanClick}
      searchTerm={searchTerm}
      setSearchTerm={setSearchTerm}
    />
  );
};

export default ElectricRouter;
